import { render } from "./NewMemberComponent.vue?vue&type=template&id=08858d06&scoped=true"
import script from "./NewMemberComponent.vue?vue&type=script&lang=js"
export * from "./NewMemberComponent.vue?vue&type=script&lang=js"

import "./NewMemberComponent.vue?vue&type=style&index=0&id=08858d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08858d06"]])

export default __exports__